export default __webpack_public_path__ + "static/media/AddClient.fd56c289.svg";